<div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div class="field">
        <label for="decMilitarData" class="font-semibold block mb-2">Dec.Militar Data</label>
        <p-inputmask id="decMilitarData" formControlName="decMilitarData" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
    </div>
    <div class="field">
        <label for="categoriaMilitar" class="font-semibold block mb-2">Categoria Militar</label>
        <p-select
            [appendTo]="'body'"
            id="categoriaMilitar"
            formControlName="categoriaMilitar"
            [options]="opcoesCategoriaMilitar()"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione"
            [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
            [readonly]="!modoEdicao()"
        />
    </div>
</div>
